
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Grid, List } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ResultsToolbarProps {
  resultCount: number;
  sortBy: string;
  setSortBy: (value: string) => void;
  viewMode: "grid" | "list";
  setViewMode: (value: "grid" | "list") => void;
}

export const ResultsToolbar = ({
  resultCount,
  sortBy,
  setSortBy,
  viewMode,
  setViewMode,
}: ResultsToolbarProps) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 pb-2 border-b">
      <div className="flex items-center gap-2">
        <p className="text-xs text-muted-foreground">
          <span className="font-medium text-foreground">{resultCount}</span> résultats trouvés
        </p>
        
        <div className="hidden sm:block h-4 w-px bg-muted-foreground/20"></div>
        
        <div className="hidden sm:block">
          <Select
            value={sortBy}
            onValueChange={setSortBy}
          >
            <SelectTrigger 
              className="h-7 text-xs border-none bg-transparent px-2 w-[120px] font-normal"
            >
              <SelectValue placeholder="Trier par" />
            </SelectTrigger>
            <SelectContent align="end">
              <SelectItem value="latest" className="text-xs">Plus récent</SelectItem>
              <SelectItem value="price-asc" className="text-xs">Prix croissant</SelectItem>
              <SelectItem value="price-desc" className="text-xs">Prix décroissant</SelectItem>
              <SelectItem value="popular" className="text-xs">Popularité</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <div className="flex items-center gap-1">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => setViewMode("grid")} 
          className={cn(
            "h-7 px-2",
            viewMode === "grid" && "bg-primary/10"
          )}
        >
          <Grid className="h-3.5 w-3.5" />
        </Button>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => setViewMode("list")} 
          className={cn(
            "h-7 px-2",
            viewMode === "list" && "bg-primary/10"
          )}
        >
          <List className="h-3.5 w-3.5" />
        </Button>
        
        <div className="sm:hidden">
          <Select
            value={sortBy}
            onValueChange={setSortBy}
          >
            <SelectTrigger 
              className="h-7 text-xs border-none shadow-none bg-transparent px-2"
            >
              <SelectValue placeholder="Trier" />
            </SelectTrigger>
            <SelectContent align="end">
              <SelectItem value="latest" className="text-xs">Plus récent</SelectItem>
              <SelectItem value="price-asc" className="text-xs">Prix croissant</SelectItem>
              <SelectItem value="price-desc" className="text-xs">Prix décroissant</SelectItem>
              <SelectItem value="popular" className="text-xs">Popularité</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};
